import { render, staticRenderFns } from "./UberCategories.vue?vue&type=template&id=2ca3e398&scoped=true"
import script from "./UberCategories.vue?vue&type=script&lang=js"
export * from "./UberCategories.vue?vue&type=script&lang=js"
import style0 from "./UberCategories.vue?vue&type=style&index=0&id=2ca3e398&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca3e398",
  null
  
)

export default component.exports